module.exports = __webpack_public_path__ + "cee0f923a2fe33953ba8877a53f0b572.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_delete.png
// module id = 4
// module chunks = 0 1 2 3 4